export default __webpack_public_path__ + "f292a8e98d62e71d81495a40fc436fe4.svg";